export function AssistantChatLoadingIndicator({ shouldRender }: { shouldRender: boolean }) {
  if (!shouldRender) return null;
  return (
    <div className={`relative max-w-64 self-start`}>
      <div className="bg-messageBubbleColor p-3 rounded-lg break-words font-medium text-sm">
        <div className="flex gap-1 justify-center items-center dark:invert">
          <span className="sr-only">Loading...</span>
          <div className="h-1 w-1 bg-black rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-1 w-1 bg-black rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-1 w-1 bg-black rounded-full animate-bounce"></div>
        </div>
      </div>
    </div>
  );
}
